// extracted by mini-css-extract-plugin
module.exports = {"content":"Profile_content__1TsNj"};